import { logD, logE, logW } from "@blacknut/logging/dist";
import { HTMLVideoElementWrappper } from "./HTMLVideoElementWrappper";
import { DefaultNativeBridge } from "../NativeBridge";
import { LOGGING_TAG } from "../../logging";
const TAG = "AndroidVideo";
export class AndroidHTMLVideoElementWrapper implements HTMLVideoElementWrappper {
  public readonly tagName = "dummy_video";
  private _bbox: DOMRect;

  private _videoWidth = 0;
  private _videoHeight = 0;
  private bridge: DefaultNativeBridge;
  constructor(brige: DefaultNativeBridge) {
    this.bridge = brige;
    this._bbox = new DOMRect(0, 0, 0, 0);
    this.bridge.send<DOMRect>("getBounds", undefined).then((res) => {
      logD(TAG, "Initial bounds : %o", res);
      this._bbox = res;
    });
    this.bridge
      .send<{ width: number; height: number }>("getVideoSize", undefined)
      .then((res) => {
        logD(TAG, "Video size : %o", res);
        this._videoWidth = res.width;
        this._videoHeight = res.height;
      })
      .catch((e) => {
        logE(LOGGING_TAG, "Caught error getting video size: %o", e);
      });
  }

  public get bbox(): DOMRect {
    return this._bbox;
  }

  public get videoWidth(): number {
    return this._videoWidth;
  }

  public get videoHeight(): number {
    return this._videoHeight;
  }

  addEventListener<K extends keyof HTMLVideoElementEventMap>(type: K) {
    logE(TAG, `${type} event not supported`);
  }

  removeEventListener<K extends keyof HTMLVideoElementEventMap>(type: K) {
    logE(TAG, `${type} event not supported`);
  }

  public play() {
    return Promise.resolve();
  }

  public getBoundingClientRect() {
    return this.bbox;
  }

  requestPointerLock() {
    logW(TAG, "unsupported");
  }

  srcObject?: MediaStream;

  public __android_onResize(data: {
    x: number;
    y: number;
    width: number;
    height: number;
  }) {
    const { x, y, width, height } = data;
    this._bbox = new DOMRect(x, y, width, height);
  }
}
